<script setup lang="tsx">
import TextView from '@/ui/common/text-view/TextView.vue'
import TruncatedTextWithTooltip from '@/ui/common/truncated-text-with-tooltip/TruncatedTextWithTooltip.vue'
import { Routes } from '@/config/router/routes'
import { AGENT_STATUS } from '@/api/modules/task-library/types'
import { useI18n } from 'vue-i18n'

interface Props {
  mainTextOverflow: string
  additionalTextOverflow: string
  agentId: string
  status: string
}

const { t } = useI18n()
const props = defineProps<Props>()
</script>
<template>
  <div :class="['LibraryCard', props.status === AGENT_STATUS.unavailable && 'unavailable']">
    <router-link
      v-if="props.status === AGENT_STATUS.healthy"
      :to="{ name: Routes.Chat, query: { agent_id: props.agentId } }"
    >
      <div class="LibraryCard--content">
        <TextView
          variant="roboto_15_semibold"
          color="gray_100"
          :class="['LibraryCard__mainText', 'LibraryCard__text']"
        >
          {{ props.mainTextOverflow }}
        </TextView>

        <TruncatedTextWithTooltip
          :text="props.additionalTextOverflow"
          :lines="3"
          variant="roboto_14_regular"
          color="gray_60"
          class="LibraryCard__additionalText"
        />
      </div>
    </router-link>
    <div v-else>
      <a-badge-ribbon :text="t('ui.badge-unavailable-text')" style="top: -4px" color="red">
        <div class="LibraryCard--content">
          <TextView
            variant="roboto_15_semibold"
            color="gray_100"
            :class="['LibraryCard__mainText', 'LibraryCard__text']"
          >
            {{ props.mainTextOverflow }}
          </TextView>

          <TruncatedTextWithTooltip
            :text="props.additionalTextOverflow"
            :lines="3"
            variant="roboto_14_regular"
            color="gray_60"
            class="LibraryCard__additionalText"
          />
        </div>
      </a-badge-ribbon>
    </div>
  </div>
</template>

<style lang="css" scoped>
.LibraryCard {
  background-color: var(--gray_white);
  border-radius: 16px;

  a {
    text-decoration: none;
  }

  &.unavailable {
    background-color: var(--gray_20);
  }
  .LibraryCard--content {
    padding: 24px;
  }
}

.LibraryCard__text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.LibraryCard__mainText {
  padding-top: 0.5px;
  margin-bottom: 6px;
  max-height: 32px;
  -webkit-line-clamp: 2;
}

.LibraryCard__additionalText {
  max-height: 48px;
}
</style>
